// ==================== REGISTRY MACCHINE SPELAFILI ====================

import { EW3035_MACHINE } from '../machines/EW-3035+L';
import { EW05_MACHINE } from '../machines/EW-05';

export { needsInnerStripping, resolveTerminal } from '../machines/shared';

/**
 * Registry centrale: ogni macchina vive nel proprio modulo in src/machines.
 * Per aggiungerne una nuova basta creare il file macchina e registrarla qui.
 */
export const MACHINES = {
    [EW3035_MACHINE.id]: EW3035_MACHINE,
    [EW05_MACHINE.id]: EW05_MACHINE
};

export const DEFAULT_MACHINE = 'EW-05';

export const getMachineList = () => {
    return Object.values(MACHINES).map(m => ({
        id: m.id,
        name: m.name,
        description: m.description
    }));
};
